import { styled } from '@mui/material';

export const IFrame = styled('iframe')(() => ({
  width: '100%',
  border: 'none',
}));
